// extracted by mini-css-extract-plugin
module.exports = {"next-sr-only":"ProcessSteps--next-sr-only--2Hjs4z5","cardTitle":"ProcessSteps--cardTitle--2Pu7Vf_","stepButton":"ProcessSteps--stepButton--1wC0q-p"};